<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-09-13 09:35:35
 * @LastEditTime: 2021-09-13 18:16:04
 * @LastEditors: chenguobiao
-->
<template>
  <div class="chessman flex items-center">
    <img :src="pieceImg" :alt="piece.captured" />
  </div>
</template>

<script>
export default {
  name: 'Chessman',
  props: {
    piece: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  components: {},
  computed: {
    pieceImg() {
      const { piece } = this
      const { color, captured = '' } = piece
      return `/assets/themes/default/${
        color === 'b' ? 'w' : 'b'
      }${captured.toUpperCase()}.png`
    },
  },
  async mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.chessman {
  display: inline-block;
  /* margin-right: val(20); */
  /* width: val(50); */
  width: val(60);
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
